import {useQueries} from "@tanstack/react-query";
import systemUsageService from "../../../../services/reports/system-usage-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['sector'],
                queryFn: () => systemUsageService.getUserSectors(),
                initialData: []
            }
        ]
    });

    return {
        sectorOptions: queries[0].data
    };
};

export default UseFetchOptions;